import axios from "axios";

class SearchDocs {
  // 1. describe and create/initiate our object
  constructor() {
    this.resultsDiv = document.querySelector("#documents");
    this.searchOverlay = document.querySelector(".search-overlay");
    this.searchField = document.querySelector(".toggle-button.active");
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.events();
    //console.log(this.searchField);
  }

  // 2. events
  events() {
    const buttons = document.querySelectorAll(".toggle-button");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.searchField = button.dataset.search;
        const slug = button.dataset.slug;
        console.log("searchField:", this.searchField);
        console.log("slug:", slug);
        this.typingLogic(slug);
      });
    });
  }

  // 3. methods (function, action...)
  typingLogic(slug) {
    if (this.searchField != this.previousValue) {
      clearTimeout(this.typingTimer);

      if (this.searchField) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>';
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(() => this.getResults(slug), 750);
      } else {
        this.resultsDiv.innerHTML = "";
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = this.searchField;
  }

  async getResults(slug) {
    try {
      const response = await axios.get(universityData.root_url + "/wp-json/university/v2/search?term=" + slug);
      const results = response.data;
      if (window.location.href.includes("/dokumentumok/")) {
        this.resultsDiv.innerHTML = `
        <div class="one-full">
          <h2 class="search-overlay__section-title">Dokumentumok</h2>
          ${
            results.dokumentumok.length
              ? ""
              : `<p>Nem találtunk ilyen dokumentumot. <a href="${universityData.root_url}/dokumentumok">Minden dokumentum megtekintése</a></p>`
          }
          ${results.dokumentumok
            .map(
              (item) => `
            <div class="dokumentum-summary">
              
              <div class="event-summary__content">
                <h5 class="event-summary__title headline headline--tiny mt-3">${item.title}</h5>
                <p>${item.content} </p>
                <button class="btn-secondary bg-orange pill white mb-2"><a href="${item.link}" class="nu white">Letölthető dokumentum</a></button>
              </div>
            </div>
          `
            )
            .join("")}
        </div>
      `;
      } else {
         // Sort vizsgahelyek based on custom conditions
  results.vizsgahelyek.sort((a, b) => {
    // Check if title contains "Elte Origó Nyelvi Centrum"
    const isElteOrigóNyelviCentrumA = a.title.includes("ELTE Origó Nyelvi Centrum");
    const isElteOrigóNyelviCentrumB = b.title.includes("ELTE Origó Nyelvi Centrum");

    // Prioritize "Elte Origó Nyelvi Centrum" first
    if (isElteOrigóNyelviCentrumA && !isElteOrigóNyelviCentrumB) {
      return -1;
    } else if (!isElteOrigóNyelviCentrumA && isElteOrigóNyelviCentrumB) {
      return 1;
    }

    // Alphabetical sorting for other titles
    return a.title.localeCompare(b.title);
  });

        this.resultsDiv.innerHTML = `
        <div class="one-full">
          <h2 class="search-overlay__section-title">Vizsgahelyek</h2>
          ${
            results.vizsgahelyek.length
              ? ""
              : `<p>Nem találtunk ilyen dokumentumot. <a href="${universityData.root_url}/vizsgahelyek">Minden vizsgahely megtekintése</a></p>`
          }
          ${results.vizsgahelyek
            .map(
              (item) => `
            <div class="dokumentum-summary">
              
              <div class="event-summary__content">
                <h5 class="event-summary__title headline headline--tiny mt-3">${item.title}</h5>
                <p>${item.content} </p>
                
              </div>
            </div>
          `
            )
            .join("")}
        </div>
      `;
      }
      this.isSpinnerVisible = false;
    } catch (e) {
      console.log(e);
    }
  }
}

export default SearchDocs;
